import React, { useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import {
  flattenData,
  getDaysBetweenMonths,
  secondsToHHMM,
} from "../../../Utilitie";

const STATrafficFlow = ({ data }) => {
  const key = [
    "tr_up",
    "tr_dn",
    "tr_pilot",
    "total",
    "td_up",
    "td_dn",
    "td_pilot",
    "total",
    "tt_up",
    "tt_dn",
    "tt_pilot",
    "total",
  ];
  const tempData = data;

  const years = [...new Set(tempData.map((o) => o.f_year))];
  const monthOrder = [
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];
  const tableRef = useRef();
  const table1 = useRef();
  const table2 = useRef();
  const table3 = useRef();
  const table4 = useRef();
  const table5 = useRef();
  const tableRefArray = [table1, table2, table3, table4, table5];
  const sum = (year, column) => {
    return tempData
      .filter((o) => o.f_year === year)
      .reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  const avg = (year, column) => {
    const items = tempData.filter((o) => o.f_year === year);
    const total = items.reduce((s, o) => s + Number(o[column] || 0), 0);
    return items.length ? (total / items.length).toFixed(2) : 0;
  };

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">
        STA TRAFFIC FLOW FINANCIAL YEAR WISE SUMMARY
      </h6>
      <div className="table-responsive">
        {years.map((year, ind) => {
          return (
            <div>
              <table
                ref={tableRefArray[years.indexOf(year)]}
                className="table table-bordered table-striped text-center "
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr className="table-dark text-center">
                    <th></th>
                    <>
                      <th colSpan={12}> STA TRAFFIC FLOW ({year})</th>
                    </>
                  </tr>
                  <tr
                    className="table-dark text-center"
                    style={{ fontWeight: "bold" }}
                  >
                    <th></th>
                    <>
                      <th colSpan={4}>TRAIN RECEIVED </th>
                      <th colSpan={4}>TRAIN DISPATCHED </th>
                      <th colSpan={4}>TOTAL TRANSACTION </th>
                    </>
                  </tr>

                  <tr
                    className="table-dark text-center align-middle"
                    style={{ fontWeight: "bold" }}
                  >
                    <th>Month</th>

                    {key.map((Head, i) => (
                      <th
                        key={i}
                        style={{
                          whiteSpace: "normal",
                        }}
                      >
                        {Head.toUpperCase().replace("_", " ")}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody key={ind}>
                  {monthOrder.map((month, i) => {
                    let tempMonths = [
                      ...new Set(
                        tempData
                          .filter((x) => x.f_year === year)
                          .map((x) => x.a_month)
                      ),
                    ];

                    if (!tempMonths.includes(month)) return null;

                    const row = tempData.find(
                      (o) => o.f_year === year && o.a_month === month
                    );

                    return (
                      <tr key={i}>
                        <td>{month}</td>

                        <td>{row?.tr_up || 0}</td>
                        <td>{row?.tr_dn || 0}</td>
                        <td>{row?.tr_pilot || 0}</td>
                        <td>{row?.tr_up + row?.tr_dn + row?.tr_pilot || 0}</td>

                        <td>{row?.td_up || 0}</td>
                        <td>{row?.td_dn || 0}</td>
                        <td>{row?.td_pilot || 0}</td>
                        <td>{row?.td_up + row?.td_dn + row?.td_pilot || 0}</td>
                        <td>{row?.tt_up || 0}</td>
                        <td>{row?.tt_dn || 0}</td>
                        <td>{row?.tt_pilot || 0}</td>
                        <td>{row?.tt_up + row?.tt_dn + row?.tt_pilot || 0}</td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="table-dark fw-bold">
                    <td>Total</td>

                    <td>{sum(year, "tr_up")}</td>
                    <td>{sum(year, "tr_dn")}</td>
                    <td>{sum(year, "tr_pilot")}</td>
                    <td>
                      {sum(year, "tr_up") +
                        sum(year, "tr_dn") +
                        sum(year, "tr_pilot")}
                    </td>

                    <td>{sum(year, "td_up")}</td>
                    <td>{sum(year, "td_dn")}</td>
                    <td>{sum(year, "td_pilot")}</td>
                    <td>
                      {sum(year, "td_up") +
                        sum(year, "td_dn") +
                        sum(year, "td_pilot")}
                    </td>

                    <td>{sum(year, "tt_up")}</td>
                    <td>{sum(year, "tt_dn")}</td>
                    <td>{sum(year, "tt_pilot")}</td>
                    <td>
                      {sum(year, "tt_up") +
                        sum(year, "tt_dn") +
                        sum(year, "tt_pilot")}
                    </td>
                  </tr>

                  <tr className="table-dark fw-bold">
                    <td>Average</td>

                    <td>{avg(year, "tr_up")}</td>
                    <td>{avg(year, "tr_dn")}</td>
                    <td>{avg(year, "tr_pilot")}</td>
                    <td>-</td>

                    <td>{avg(year, "td_up")}</td>
                    <td>{avg(year, "td_dn")}</td>
                    <td>{avg(year, "td_pilot")}</td>
                    <td>-</td>

                    <td>{avg(year, "tt_up")}</td>
                    <td>{avg(year, "tt_dn")}</td>
                    <td>{avg(year, "tt_pilot")}</td>
                    <td>-</td>
                  </tr>
                </tfoot>
              </table>{" "}
              <div className="mb-3">
                <DownloadExcel
                  tableRef={tableRefArray[years.indexOf(year)]}
                  fileName={`Financial Year Summary STA Yard Ex  - ${year}`}
                />
              </div>
            </div>
          );
        })}{" "}
      </div>{" "}
    </div>
  );
};

export default STATrafficFlow;
